// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hint_wrapper__kzneY","hints":"Hint_hints__Vn9CN","maxHeight300":"Hint_maxHeight300__itf1b","active-hint":"Hint_active-hint__O2u6a","hint":"Hint_hint__4Mttk"};